<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          show-expand
          class="elevation-1"
        >
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteEsusPecGlobal
                :texto="texto_esus_pec"
                :data="data_esus_pec"
              />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>

          <template v-slot:header.micro_area="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Microárea do ACS"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            {{ formatDate(item.dt_nascimento) }}
          </template>

          <!-- semanas_gestacao_primeira_consulta  -->
          <template v-slot:item.semanas_gestacao_primeira_consulta="{ item }">
            <span
              class="font-weight-bold"
              :class="
                item.semanas_gestacao_primeira_consulta <= 12 ? 'green' : 'red'
              "
              >{{
                item.semanas_gestacao_primeira_consulta <= 12 ? 'Sim' : 'Não'
              }}
              ({{ item.semanas_gestacao_primeira_consulta }})</span
            >
          </template>
          <template
            v-slot:header.semanas_gestacao_primeira_consulta="{ header }"
          >
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="A gestante iniciou pré-natal até a 12ª semana de Gestação?"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <!-- quantidade_consultas  -->
          <template v-slot:item.quantidade_consultas="{ item }">
            <span
              class="font-weight-bold"
              :class="
                item.quantidade_consultas >= 6 &&
                item.semanas_gestacao_primeira_consulta <= 12
                  ? 'green'
                  : 'red'
              "
            >
              {{ item.quantidade_consultas >= 6 ? 'Sim' : 'Não' }}
              ({{ item.quantidade_consultas }})</span
            >
          </template>
          <template v-slot:header.quantidade_consultas="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="A gestante tem 6 ou mais consultas de pré-natal?"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <!-- quantidade_atendimentos_odonto  -->
          <template v-slot:item.quantidade_atendimentos_odonto="{ item }">
            <span
              class="font-weight-bold"
              :class="
                item.quantidade_atendimentos_odonto >= 1 ? 'green' : 'red'
              "
            >
              {{ item.quantidade_atendimentos_odonto >= 1 ? 'Sim' : 'Não' }} ({{
                item.quantidade_atendimentos_odonto
              }})</span
            >
          </template>
          <template v-slot:header.quantidade_atendimentos_odonto="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="A gestante realizou consulta de odontologia durante a gestação?"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <!-- dt_ultimo_teste_hiv  -->
          <template v-slot:item.dt_ultimo_teste_hiv="{ item }">
            <span
              class="font-weight-bold"
              :class="
                (item.dt_ultimo_teste_hiv != null &&
                  item.dt_ultimo_teste_sifilis != null) ||
                (item.dt_ultima_sorologia_hiv != null &&
                  item.dt_ultima_sorologia_sifilis != null) ||
                (item.dt_ultimo_teste_hiv != null &&
                  item.dt_ultima_sorologia_sifilis != null) ||
                (item.dt_ultimo_teste_sifilis != null &&
                  item.dt_ultima_sorologia_hiv != null)
                  ? 'green'
                  : 'red'
              "
              >{{
                (item.dt_ultimo_teste_hiv != null &&
                  item.dt_ultimo_teste_sifilis != null) ||
                (item.dt_ultima_sorologia_hiv != null &&
                  item.dt_ultima_sorologia_sifilis != null) ||
                (item.dt_ultimo_teste_hiv != null &&
                  item.dt_ultima_sorologia_sifilis != null) ||
                (item.dt_ultimo_teste_sifilis != null &&
                  item.dt_ultima_sorologia_hiv != null)
                  ? 'Sim'
                  : 'Não'
              }}</span
            >
          </template>
          <template v-slot:header.dt_ultimo_teste_hiv="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="A gestante realizou exames para detecção de HIV e Sífilis durante a gestação?"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <!-- tipo_atendimento  -->
          <template v-slot:item.tipo_atendimento="{ item }">
            <span class="font-weight-bold">{{
              item.tipo_atendimento == 1 ? 'Aberta' : 'Fechada'
            }}</span>
          </template>

          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="10">
              <table class="table table-interna">
                <thead>
                  <tr>
                    <th>CNS / CPF</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <show-hide-field
                        :value="item.nu_cpf_cns"
                      ></show-hide-field>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'

export default {
  name: 'TabelaCadastrosVuetfy',
  components: {
    ShowHideField,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    data_secretaria_de_saude: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    texto_esus_pec: {
      type: String,
      default: '',
    },
    data_esus_pec: {
      type: String,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        {
          text: 'MA',
          align: 'start',
          filterable: false,
          value: 'micro_area',
        },
        {
          text: '< 12 Semanas',
          align: 'start',
          filterable: false,
          value: 'semanas_gestacao_primeira_consulta',
        },
        {
          text: 'Pré-Natal?',
          align: 'start',
          filterable: false,
          value: 'quantidade_consultas',
        },
        {
          text: 'Odonto?',
          align: 'start',
          filterable: false,
          value: 'quantidade_atendimentos_odonto',
        },
        {
          text: 'HIV e Sífilis?',
          align: 'start',
          filterable: false,
          value: 'dt_ultimo_teste_hiv',
        },
        {
          text: 'Gestação',
          align: 'start',
          filterable: false,
          value: 'tipo_atendimento',
        },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        id: index,
        ...item,
      }))
    },
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },
    getPagination(options) {
      this.currentPage = options.page
    },
  },
}
</script>

<style scoped lang="scss">
.font-weight-bold {
  font-weight: bold;
}
.green {
  background-color: unset !important;
  color: green;
}
.red {
  background-color: unset !important;
  color: red;
}
</style>
